import React, { forwardRef, useCallback } from 'react';
import PropTypes from 'prop-types';

const Scrollbar = forwardRef(({ children, onReady, style, ...other }, ref) => {
    const setRef = useCallback((node) => {
        if (!node) return;
        if (ref) {
            if (typeof ref === 'function') ref(node);
            else ref.current = node;
        }
        if (typeof onReady === 'function') onReady(node);
    }, [ref, onReady]);

    return (
        <div ref={setRef} style={{ overflow: 'auto', ...style }} {...other}>
            {children}
        </div>
    );
});

Scrollbar.propTypes = {
    children: PropTypes.node,
    onReady: PropTypes.func,
    style: PropTypes.object,
};

export default Scrollbar;